import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import Badge from '../Badge'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'
import { SummaryBarContainer, SummaryBarLabel } from './styled'

const SummaryBar: FunctionComponent<ISummaryBarProps & IWithSize> = ({
  count = 0,
  maxResults = 0,
  size = 1,
}) => {
  const [t] = useTranslation()
  const countText =
    maxResults > 0 && count > maxResults ? `${maxResults}+` : count

  return (
    <SummaryBarContainer size={size}>
      <SummaryBarLabel size={size}>
        {count > 0 ? t('BBO_918_search_results') : t('search_not_found')}
      </SummaryBarLabel>
      <div style={{ marginLeft: `${10 * size}px` }} />
      {count > 0 && <Badge size={size}>{countText}</Badge>}
    </SummaryBarContainer>
  )
}

export default SummaryBar

export interface ISummaryBarProps {
  count: number
  maxResults?: number
}
